import axios from 'axios'
import store from '@/store'
import router from '@/router'
import Qs from 'qs'
import Vue from 'vue';
import { SET_LOGIN_USER } from '@/store/mutation-types'

// 創建 axios 配置基礎
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // url = base url + request url
  withCredentials: true, //是否開啟跨域請求并發送cookies
  timeout: 5 * 60 * 1000, // 請求五分钟超時
  paramsSerializer: function (params) { //get 時進行數據格式化
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  }
})
// 攔截請求
service.interceptors.request.use(
  config => {
    // 在發送請求前，在請求頭中加入認證

    config.enableLoading = config.enableLoading === undefined ? true : config.enableLoading;

    if (config.enableLoading) {
      Vue.prototype.$loading.show();
    }
    var user = store.getters.user;
    if (user != null) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = "Bearer " + user.token;
    }
    config.headers['Accept-Language'] = store.getters.lang;


    return config
  },
  error => {
    // 處理請求錯誤
    self.console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 響應攔截
service.interceptors.response.use(

  /**
   * 驗證請求結果，對特定的錯誤狀態做處理
   */
  response => {
    const res = response.data;
    if (response.config.enableLoading) {
      Vue.prototype.$loading.close();
    }
    console.log(response.url);
    // if (response.url = "/authenticate/AuthenticateLogin") {

    // }

    //  if(response.url="/authenticate/AuthenticateLogin" && res.code==200)
    // 請結果不等于0則，服務器返回錯誤信息
    if (res.code !== 200) {
      if (res.code === 100) {
        //錯誤信息，這些錯誤可能需要處理

        return res
      }
      if (res.code === 203) {
        //錯誤信息，這些錯誤可能需要處理,清空掉当前用户的基本信息
        store.commit(SET_LOGIN_USER, null);
        return res
      }
      alert(res.message || 'Error');


      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {

    Vue.prototype.$loading.close();
    // if(response.config.url="/UserAwbQuery/GetUserAwbQueryList "){
    //   return Promise.reject(error)
    // }
    // console.log(error.response)
    if (error.config && error.config.iserror == true) {
      return Promise.reject(error)
    }


    if (error.response && error.response.status === 401) {
      alert(Vue.prototype.i18n.t('login_expired'));
      store.commit(SET_LOGIN_USER, null);
      router.push({ name: "login" });
      return;
    }

    self.console.log('err ' + error); // for debug    
    let message = error.message;
    if (error.message.indexOf("Network Error") != -1) {
      message = Vue.prototype.i18n.t('network_error');
    } else if (error.message.indexOf("timeout") != -1) {
      message = Vue.prototype.i18n.t('request_timeout');
    }
    alert(message);
    return Promise.reject(error)
  }
)
export default service
